import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('select_the_requesters'),
    subtitle: defineMessage('requesters_are_users_au_approval_in_approvalmax'),
    allUsers: defineMessage('all_users'),
};
